module.exports = __webpack_public_path__ + "img/car_00062.ef18befe.jpg";